/**
 * Returns an array of languages with Word complexity support.
 *
 * @returns {string[]} A list of languages that have Word complexity support.
 */
export function getLanguagesWithWordComplexity() {
	return [ "en", "es", "de", "fr" ];
}
